module.exports = __webpack_public_path__ + "img/video-uni.e44bcd98.png";